<template>
  <section v-if="members.length" class="team-section">
    <div class="container">
      <h2 class="title">{{ heading }}</h2>
      <div class="grid">
        <article v-for="m in members" :key="m.id" class="member">
          <div class="photo">
            <img v-if="m.photoUrl" :src="m.photoUrl" :alt="m.name" />
            <span v-else class="placeholder">{{ initials(m) }}</span>
          </div>
          <h3>{{ m.name }}</h3>
          <p class="position" v-if="position(m)">{{ position(m) }}</p>
          <a v-if="m.linkedInUrl" :href="m.linkedInUrl" target="_blank" rel="noopener" class="linkedin">LinkedIn</a>
        </article>
      </div>
    </div>
  </section>
</template>

<script>
import axios from "axios";

const HEADINGS = {
  az: "Komandamız",
  de: "Unser Team",
  en: "Our team",
  ru: "Наша команда",
  tr: "Ekibimiz",
};

export default {
  name: "TeamSection",
  data() {
    return { members: [] };
  },
  computed: {
    lang() { return this.$store.state.lang || "az"; },
    heading() { return HEADINGS[this.lang] || HEADINGS.az; },
  },
  mounted() { this.load(); },
  methods: {
    async load() {
      try {
        const res = await axios.get(`/home/team`);
        this.members = res.data?.data || [];
      } catch {
        this.members = [];
      }
    },
    position(m) {
      const k = `position_${this.lang}`;
      return m[k] || m.position_az || m.position_en || m.position_de || "";
    },
    initials(m) {
      return ((m.name || "").charAt(0) || "?").toUpperCase();
    },
  },
};
</script>

<style lang="scss" scoped>
.team-section { padding: 3rem 0; background: #f8fafc; }
.title { color: #1e3c72; text-align: center; font-size: 1.6rem; margin-bottom: 2rem; }
.grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(220px, 1fr)); gap: 1.25rem; }
.member { background: #fff; border-radius: 12px; padding: 1.25rem; text-align: center; box-shadow: 0 2px 8px rgba(0,0,0,0.05);
  .photo { width: 120px; height: 120px; margin: 0 auto 0.85rem; border-radius: 50%; overflow: hidden; background: #e6f0ff; display: flex; align-items: center; justify-content: center;
    img { width: 100%; height: 100%; object-fit: cover; }
    .placeholder { font-size: 2.5rem; color: #2a5298; font-weight: 600; }
  }
  h3 { color: #1e3c72; font-size: 1rem; margin: 0 0 0.25rem; }
  .position { color: #64748b; font-size: 0.85rem; margin: 0 0 0.5rem; }
  .linkedin { font-size: 0.8rem; color: #2a5298; text-decoration: none; &:hover { text-decoration: underline; } }
}
</style>
